import { makeAutoObservable } from 'mobx'
import { v4 as uuidv4 } from 'uuid'
import PPQuestion from './Question'

export default class PPSlide {
    id = uuidv4()

    title = ''

    hasCustomTitle = false

    template = ''

    exportWithoutHeadlines = false

    question = new Map()

    constructor(props = {}) {
        this.title = props.title ?? ''
        this.hasCustomTitle = props.hasCustomTitle ?? false
        this.template = props.template ?? ''
        this.exportWithoutHeadlines = props.exportWithoutHeadlines ?? false

        if (props.question instanceof Map) {
            this.question = props.question
        }

        makeAutoObservable(this)
    }

    get slideTitle() {
        if (this.hasCustomTitle && this.title) return this.title

        const generatedTitle = Array.from(this.question?.values()).map((q) => q.questionShortText).join('/')

        return generatedTitle || this.title
    }

    getQuestionAtPosition(position) {
        return this.question.get(position)
    }

    addQuestion(position, question) {
        this.question.set(position, new PPQuestion(question, this.store))
    }

    removeQuestion(position) {
        this.question.delete(position)
    }

    updateTitle(event) {
        this.title = event.value
        this.hasCustomTitle = !!event.value
    }

    updateTemplate(template) {
        this.template = template
    }

    getQuestionCharts() {
        const questions = [...this.question.values()]

        return questions.map((q) => q.chart)
    }

    get questionIds() {
        const ids = []
        this.question.forEach((q) => {
            if (q.questionId) ids.push(q.questionId)
            if (q.kpiQuestionId) ids.push(q.kpiQuestionId)
            q.questions?.forEach((nested) => {
                if (nested?.questionId) ids.push(nested.questionId)
            })
        })
        return ids
    }

    questionIdsForSurvey(surveyId) {
        const ids = []
        this.question.forEach((q) => {
            if (q.surveyId !== surveyId) return
            if (q.questionId) ids.push(q.questionId)
            if (q.kpiQuestionId) ids.push(q.kpiQuestionId)
            q.questions?.forEach((nested) => {
                if (nested?.questionId) ids.push(nested.questionId)
            })
        })
        return ids
    }

    toJSON = () => ({
        id: this.id,
        title: this.title,
        hasCustomTitle: this.hasCustomTitle,
        template: this.template,
        exportWithoutHeadlines: this.exportWithoutHeadlines,
        question: Array.from(this.question.values()),
    })
}
